import { useState } from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Stack, Typography } from "@mui/material";
import { LightbulbOutlined as IdeaIcon } from "@mui/icons-material";
import { useLocation, useNavigate } from "react-router-dom";
import { sugerenciaService } from "../../services/sugerenciaService";
import { useAuthStore } from "../../stores/authStore";
import { tokens } from "../../theme";

/**
 * Presenta la funcionalidad de sugerencias la primera vez que alguien entra.
 *
 * "Ya lo vi" se guarda en el servidor (`Persona.vio_aviso_sugerencias`), no en
 * el navegador: se muestra una vez por persona, no una por equipo. Si la llamada
 * falla se cierra igual —insistir con un aviso es peor que perdérselo— y volverá
 * a aparecer en la siguiente sesión.
 */
export default function AvisoSugerencias() {
  const { user, marcarAvisoSugerenciasVisto } = useAuthStore();
  const navigate = useNavigate();
  const location = useLocation();
  const [cerrado, setCerrado] = useState(false);

  const abierto = !!user && user.vio_aviso_sugerencias === false && !cerrado;

  const marcarVisto = async () => {
    setCerrado(true);
    marcarAvisoSugerenciasVisto();
    try {
      await sugerenciaService.marcarAvisoVisto();
    } catch {
      // Sin registro en el servidor volverá a aparecer; no vale un mensaje de error.
    }
  };

  const irASugerencias = async () => {
    await marcarVisto();
    navigate("/app/sugerencias", { state: { desde: location.pathname + location.search } });
  };

  return (
    <Dialog open={abierto} onClose={marcarVisto} maxWidth="xs" fullWidth>
      <DialogTitle sx={{ pb: 1 }}>
        <Stack direction="row" spacing={1.25} alignItems="center">
          <IdeaIcon sx={{ color: tokens.naranjo[400] }} />
          Ahora puedes sugerir mejoras
        </Stack>
      </DialogTitle>
      <DialogContent>
        <Typography variant="body2" color="text.secondary">
          Si algo te falta, te estorba o crees que se puede hacer mejor, escríbelo en <strong>Sugerencias</strong> —
          está al final del menú. Tu mensaje llega directo al equipo que desarrolla el sistema.
        </Typography>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={marcarVisto}>Ahora no</Button>
        <Button variant="contained" onClick={irASugerencias}>
          Ver Sugerencias
        </Button>
      </DialogActions>
    </Dialog>
  );
}
